module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.main.loaded.single) ? _c('div', {
    staticClass: "single-container"
  }, [(!_vm.main.loaded.text) ? _c('div', {
    attrs: {
      "id": "exit"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', [_vm._v("exit full-screen")])]) : _vm._e(), _vm._v(" "), (_vm.main.single.acf.audio) ? _c('div', {
    attrs: {
      "id": "audio-container"
    }
  }, [_c('audio', {
    attrs: {
      "src": _vm.main.single.acf.audio.url,
      "controls": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.main.single.acf.video) ? _c('div', {
    attrs: {
      "id": "video-container"
    }
  }, [_c('iframe', {
    attrs: {
      "src": 'https://player.vimeo.com/video/' + _vm.main.single.acf.video + '?title=0&byline=0&portrait=0',
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : (_vm.main.single.acf.Image_display === "Full screen" && _vm.mainImage.length > 0) ? _c('img', {
    staticClass: "full",
    attrs: {
      "src": _vm.mainImage
    }
  }) : _c('img', {
    staticClass: "fit",
    attrs: {
      "src": _vm.mainImage
    }
  }), _vm._v(" "), (_vm.main.horizontal.context && _vm.main.horizontal.context.length > 0) ? _c('div', [_c('div', {
    staticClass: "nav prev",
    on: {
      "click": _vm.prevItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav next",
    on: {
      "click": _vm.nextItem
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a35add2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/single.vue
// module id = 472
// module chunks = 2